import './home.scss'

import { defineComponent } from 'vue';

import { UserAuthenticatedResult } from '@skinsoft/auth';
import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { appsConfig } from '../../../../config/apps.config';
import { router, Routes } from '../../../router';

declare const APPS_TO_DEPLOY: string[];

export const Home = defineComponent({
    mixins: [reactiveVueMixin],
    components: {

    },
    template: require('./home.html'),
    data() {
        return {
            appLauncherIconsData: [] as any[],
        }
    },
    created() {
        for (const appConfigName of APPS_TO_DEPLOY) {
            const appConfig = appsConfig[appConfigName]

            const titleKey = appConfig.nameI18NKey
            const title: string = this.$t(titleKey, this.$i18n.locale) as string
            this.appLauncherIconsData.push(
                {
                    appId: appConfig.id,
                    defaultRouteName: appConfig.defaultRouteName,
                    title,
                }
            )
        }
    },
    mounted() {
        this.subscribeTo(this.$authService.waitForUser$(), this.onUser);
    },
    methods: {
        emitApplicationChangeEvent(applicationName: string, defaultRoute: string) {
            setTimeout(() => this.$parent?.$emit("application-change-topic", applicationName, defaultRoute), 300)
        },
        onUser(userAuthResult: UserAuthenticatedResult | null) {
            if (userAuthResult?.user) {
                return;
            }

            if (router.currentRoute.value.name !== Routes.LOGIN) {
                router.push({ name: Routes.LOGIN });
            }
        },
    },
})
